import { EditNote, LockReset } from "@mui/icons-material";
import { Typography, Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Form from "../../components/app/forms/login/form";
import { getRouteUrl } from "../../helpers/routing/getRouteUrl";
import useLogin from "../../hooks/login/useLogin";
import useUserData from "../../hooks/user/useUserData";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";
import {ROUTE_CHANGE_PASSWORD, ROUTE_NEW_ACCOUNT, ROUTE_PAGE_INITIAL, ROUTE_VERIFICATION} from "../../routers/routes";
import PageContentWrapper from "../../components/mui/app/pageContentWrapper/pageContentWrapper";
import {useParams} from "react-router";
import LanguageSelect from "../../components/app/languageSelect/languageSelect";
import React from "react";
import Images from "../../assets";

const Login = () => {
	const { campaign } = useParams();
	const { t } = useTranslation(PAGE_LOGIN);
	const { loading } = useUserData();
	const { formik } = useLogin({campaign});
	const history = useHistory();

	return (
		<PageContentWrapper>
			<Box
				sx={{
					pt:0,
					width: "100%",
					minHeight: "100vh",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					px: 2
				}}
			>

				<Box
					sx={{
						width: 540,
						minHeight: 440,
						display: "flex",
						flexDirection: "column",
						borderRadius: "30px",
						overflow: "hidden",
						boxShadow: "0px 40px 40px rgba(0,0,0,0.4)",
						position: "relative",
						backdropFilter: "blur(10px)"
					}}
				>
					<Box
						sx={{
							width: "100%",
							height: 108,
							background: "#FFFFFF",
							borderRadius: "30px 30px 0 0",
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							boxShadow: "0px 20px 40px rgba(0,0,0,0.48)",
							zIndex: 2,
						}}
					>
						{/*<Box*/}
						{/*	sx={{*/}
						{/*		ml:2,*/}
						{/*		width: "60%",*/}
						{/*		height: 20,*/}
						{/*		borderRadius: "5px",*/}
						{/*		background:*/}
						{/*			"linear-gradient(90deg, #004B88 10%, #007FBD 58%, #009DDC 90%)",*/}
						{/*	}}*/}
						{/*/>*/}
						<Box
							component="img"
							src={Images.bigLogoNew}
							alt="logo"
							sx={{
								ml:2,
								display:'flex',
								width: "50%",
								height:'40%'
							}}
						/>
						<LanguageSelect color={'#000000'}/>
					</Box>

					<Box
						sx={{
							flex: 1,
							width: "100%",
							background:
								"linear-gradient(180deg, rgba(255,255,255,0.01) 50%, rgba(216,216,216,0.01) 100%)",
							backdropFilter: "blur(10px)",
							px: 4,
							py: 5,
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							color: "#fff",
						}}
					>

						<Typography
							sx={{
								fontWeight: 700,
								fontSize: 22,
								mb: 2,
								textAlign: "center",
							}}
						>
							{/*{t("30for30Title")}*/}
						</Typography>
						<Typography
							sx={{
								fontWeight: 700,
								fontSize: 22,
								mb: 2,
								textAlign: "center",
							}}
						>
							{t("Grant application portal")}
						</Typography>
						<Box sx={{ width: "100%", mt: 1 }}>
							<Form formik={formik} loading={loading} />
						</Box>

						<Box
							sx={{
								mt: 3,
								width: "100%",
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								gap: 1.2
							}}
						>
							<Typography
								sx={{
									color: "rgba(255,255,255,0.9)",
									fontSize: 14
								}}
							>
								{t("First-time applicant?")}{" "}
								<span
									style={{
										textDecoration: "underline",
										cursor: "pointer"
									}}
									onClick={() => history.push(getRouteUrl(ROUTE_NEW_ACCOUNT,{campaign}))}
								>
									{t("Create an account")}
								</span>
							</Typography>

							<Typography
								sx={{
									color: "rgba(255,255,255,0.9)",
									fontSize: 14
								}}
							>
								{t("Forgot password?")}{" "}
								<span
									style={{
										textDecoration: "underline",
										cursor: "pointer"
									}}
									onClick={() => history.push(getRouteUrl(ROUTE_CHANGE_PASSWORD,{campaign}))}
								>
									{t("Reset it")}
								</span>
							</Typography>
						</Box>
					</Box>
				</Box>
			</Box>
		</PageContentWrapper>
	);
};

export default Login;
